<app-row [formGroup]="gateDefinitionForm">
  <app-col cols=12 class="mb-2">
    <mat-radio-group formControlName="type" color="primary">
      <mat-radio-button class="mr-3" [value]="gateDefinitionEnum.InBound" >{{'sharedFeatures.GateDefinition.inBound' | translate}}</mat-radio-button>
      <mat-radio-button class="mr-3" [value]="gateDefinitionEnum.OutBound">{{'sharedFeatures.GateDefinition.outBound' | translate}}</mat-radio-button>
      <mat-radio-button [value]="gateDefinitionEnum.Both">{{'sharedFeatures.GateDefinition.both' | translate}}</mat-radio-button>
    </mat-radio-group>
  </app-col>

  <app-col cols="12">
    <div class="flex column temperature-control">
      <mat-checkbox formControlName="temperatureControl" color="primary" class="pb-6">
        <div class="text-700">{{'sharedFeatures.GateDefinition.temperatureControl' | translate}}</div>
        <div class="text-500">{{'sharedFeatures.GateDefinition.temperatureControlText' | translate}}</div>
      </mat-checkbox>
    </div>
  </app-col>

  <app-col cols="4">
    <div class="ml-3">
      <mat-label class="asterisk-after w-100 d-block">{{ "sharedFeatures.GateDefinition.gateName" | translate }}</mat-label>
      <mat-form-field appearance="outline" class="d-block w-100">
        <input
          matInput
          type="text"
          formControlName="name"
        />
        <mat-error
          *ngIf="
            gateDefinitionForm.invalid &&
            gateDefinitionForm.get('name').touched &&
            gateDefinitionForm.get('name').hasError('required')
          ">
          {{ "ErrorMessages.Required" | translate }}
        </mat-error>
      </mat-form-field>
    </div>
  </app-col>

  <app-col cols="4" *ngIf="gateDefinitionForm.value.temperatureControl">
    <div>
      <mat-label class="asterisk-after w-100 d-block">{{ "sharedFeatures.GateDefinition.truckClassify" | translate }}</mat-label>
      <mat-form-field appearance="outline" class="d-block w-100">
        <mat-select formControlName="truckClassify"
        >
          <mat-option value="AMB">AMB</mat-option>
          <mat-option value="Frozen">{{ "sharedFeatures.GateDefinition.Frozen" | translate }}</mat-option>
          <mat-option value="Chiller">{{ "sharedFeatures.GateDefinition.Chiller" | translate }}</mat-option>
        </mat-select>

        <mat-error
        *ngIf="
          gateDefinitionForm.get('truckClassify').touched &&
          gateDefinitionForm.get('truckClassify').hasError('required')
        ">
          {{ "ErrorMessages.Required" | translate }}
        </mat-error>
      </mat-form-field>
    </div>
  </app-col>

  <app-col cols="4">
    <mat-label class="w-100 d-block">{{ "sharedFeatures.GateDefinition.referenceID" | translate }}</mat-label>
    <mat-form-field appearance="outline" class="d-block w-100">
      <input
        matInput
        type="text"
        formControlName="reference"
      />
    </mat-form-field>
  </app-col>
</app-row>
